import React, { useState } from 'react';
import { connectHits } from 'react-instantsearch-dom';

import LibrarySearchEmpty from './LibrarySearchEmpty';
import LibrarySearchHit from './LibrarySearchHit';
import LibrarySearchViewMore from './LibrarySearchViewMore';

const DEFAULT_HITS = 6;

const LibrarySearchHits = connectHits(({ hits }) => {
  const [hitLength, setHitLength] = useState(DEFAULT_HITS);
  if (!hits.length) return <LibrarySearchEmpty />;

  const handleViewMore = () => {
    setHitLength((currVal) => currVal + 12);
  };
  return (
    <>
      <div className="global-padding-container">
        <h4 className="stink-h4 text-smoke">
          {hits.length}
          {hits.length >= 20 && `+`} Results Found
        </h4>
      </div>
      <div className="mt-6 border-b border-smoke border-opacity-30 lg:mt-8" />
      {hits.slice(0, hitLength).map((hit) => {
        return <LibrarySearchHit key={hit.objectID} hit={hit} />;
      })}
      {hits.length > hitLength && (
        <div className="global-padding-container">
          <div className="flex justify-center w-full py-10 lg:py-20">
            <LibrarySearchViewMore handleViewMore={handleViewMore} />
          </div>
        </div>
      )}
    </>
  );
});

export default LibrarySearchHits;
